import moment, { HTML5_FMT, Moment, MomentInput } from "moment";

const toMoment = (date: MomentInput | null | undefined): Moment | null => {
    if (date) {
        const momentDate = moment(date);
        if (momentDate.isValid()) {
            return momentDate;
        }
    }

    return null;
};

export const toDate = (date: MomentInput | null | undefined): Date | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.toDate() : null;
};

export const toDateUtc = (date: MomentInput | null | undefined): Date | null => {
    if (date) {
        const momentDate = moment.utc(date);
        if (momentDate.isValid()) {
            return momentDate.toDate();
        }
    }

    return null;
};

export const toDateUtcString = (date: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.utc().format(HTML5_FMT.DATE) : null;
};

export const toDateTimeString = (date: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.toISOString() : null;
};

export const toDateString = (date: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.format(HTML5_FMT.DATE) : null;
};

export const toDateStringWeekday = (date: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.toDate().toDateString() : null;
};

export const toUTCDateStringWeekday = (date: MomentInput | null | undefined): string | null => {
    const momentDate = date ? moment(date).utc() : null;
    return momentDate ? momentDate.format("ddd, MMM D YYYY") : null;
};

export const toTimeString = (date: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.format(HTML5_FMT.TIME) : null;
};

export const toLocaleDateString = (date?: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? momentDate.format("L") : null;
};

export const toLocaleDateTimeString = (date?: MomentInput | null | undefined): string | null => {
    const momentDate = toMoment(date);
    return momentDate ? `${momentDate.format("L")} ${momentDate.format("LTS")}` : null;
};

export const setTimezone = (date: MomentInput, timezoneOffset?: number | null): string | null => {
    const momentDate = moment.utc(date);
    let offset = timezoneOffset ? timezoneOffset : 0;
    offset *= -1;
    return momentDate ? momentDate.add(offset, "minutes").format("MM/DD/YYYY h:mma") : null;
};
